<template>
  <fin-data-loader :resolver="loadData">
    <v-row v-if="viewModes.length > 0">
      <v-col v-if="!hidePromoCodeOffer && promoCodeHtml && !isApp" align="center" cols="12">
        <div class="align-center justify-center ma-0 pa-0" v-html="promoCodeHtml"/>
      </v-col>
      <v-col cols="12" v-if="groupPriceModel">
        <p v-if="aboSuccessfullyChanged">Dein Abo wurde erfolgreich auf {{ groupPriceModel.id }} geändert.</p>
        <p v-else-if="aboSuccessfullyChanged !== null && profile.subscriptionChange !== groupPriceModel.id">
          Dein Abo konnte nicht
          <span v-if="profile.subscriptionChange"> auf {{ profile.subscriptionChange }} </span>
          geändert werden. Dein aktuelles Abo ist {{ groupPriceModel.id }}.<br/>
          Versuche es bitte später erneut. Falls weiterhin Probleme auftreten, kontaktiere uns:
          <a href="mailto:support@fincraft.de">support@fincraft.de</a>
        </p>
        <p v-else-if="groupPriceModel.id === 'TRIAL' && hasSubscriptionChanged">
          Als neu registrierter Kunde erhältst du alle Funktionen und Privilegien unseres Advanced Programms
          <span v-if="profile.subscriptionChangeDate">noch bis zum {{ profile.subscriptionChangeDate | date }}</span>.
        </p>
        <p
          v-else-if="hasSubscriptionChanged && groupPriceModel.id !== 'BASIC' && groupPriceModel.id !== 'TRIAL' && profile.subscriptionChange === 'BASIC'">
          Wir bedauern die Kündigung deines Abos und bedanken uns für die Nutzung unserer Services. Du kannst
          den vollen Umfang des Abos <em>{{ groupPriceModel.id }}</em> noch
          <span v-if="subscriptionData && subscriptionData.periodEnd">bis zum {{
              subscriptionData.periodEnd | date
            }}</span>
          nutzen, danach wird dein Benutzerkonto auf das kostenlose <em>{{ profile.subscriptionChange }}</em> Abo
          heruntergestuft.
        </p>

        <p class="mt-3" v-if="isApp">
          Auf <a :href="subscriptionWebUrl">fincraft.de</a> findest du weitere Informationen über unser Angebot und
          kannst ein
          Abo
          abschließen bzw. dein Abo verwalten.
        </p>

        <p
          v-else-if="hasSubscriptionChanged && groupPriceModel.id !== 'TRIAL' && profile.subscriptionChange !== 'BASIC'">
          Du hast dein Abo
          <span v-if="profile.subscriptionChangeDate">zum {{ profile.subscriptionChangeDate | date }}</span>
          von {{ groupPriceModel.id }} auf {{ profile.subscriptionChange }} geändert. Dein neues Profil gilt ab morgen.
        </p>
      </v-col>

      <v-col v-for="(priceDef, index) in priceModels"
             :key="index" class="pa-5"
             cols="12" md="4">
        <fin-subscription-card
          :ref="groupPriceModel && groupPriceModel.id === priceDef.id ? 'selectedAbo' : 'abo_' + priceDef.id"
          :price-model="priceDef"
          @selectNewSubscription="val => selectNewSubscription(val)"
          @showSubscriptionDetails="val => showSubscriptionDetails(val)"
          @changeAboDuration="val => changeAboDuration(val)"/>
      </v-col>

    </v-row>
  </fin-data-loader>
</template>

<script>
import FinSubscriptionCard from "@/components/pages/profile/subscription/Card"
import {mapGetters} from "vuex"
import finBrowser from "@/js/finBrowser"
import BaseUrl from "@/mixins/BaseUrl"
import FinDataLoader from "@/components/common/DataLoader"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {getSubscriptionData} from "@/components/pages/profile/subscription/graphql"

export default {
  name: "FinSubscriptionCards",
  components: {FinDataLoader, FinSubscriptionCard},
  props: {
    priceModels: {
      type: Array,
      default: () => [],
    },
    viewModes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      aboSuccessfullyChanged: null,
      isApp: finBrowser.IS_IOS_OR_ANDROID_APP,
      subscriptionData: undefined,
      subscriptionWebUrl: undefined,
      hidePromoCodeOffer: process.env.VUE_APP_HIDE_PROMOCODE_OFFER === 'true',
      promoCodeHtml: process.env.VUE_APP_PROMOCODE_HTML_ABO_PAGE
    }
  },
  mixins: [BaseUrl],
  computed: {
    ...mapGetters('auth', ['groupPriceModel', 'profile']),
    hasSubscriptionChanged() {
      return this.$route.path.includes('protected') && this.groupPriceModel &&
        this.profile.subscriptionChange && this.profile.subscriptionChange !== this.groupPriceModel.id
    },
  },
  methods: {
    async loadData() {
      try {
        // check if the user is logged in, as the user is not logged in when he accesses the url /abonnements (access via webflow and iframe)
        if (this.groupPriceModel) {
          let result = await API.graphql(graphqlOperation(getSubscriptionData))
          if (result) {
            this.subscriptionData = result.data.getSubscriptionData
          }
        }
      } catch (err) {
        console.error("failed to get the subscription data", err)
      }
    },
    selectNewSubscription(val) {
      this.$emit('selectNewSubscription', val)
    },
    showSubscriptionDetails(val) {
      this.$emit('showSubscriptionDetails', val)
    },
  },
  mounted() {
    this.subscriptionWebUrl = this.getBaseURL() + "/protected/myProfile/subscription"

    // to scroll to the selected abo on mobiles
    if (this.$vuetify.breakpoint.xs && this.$refs.selectedAbo) {
      setTimeout(() => {
        window.scrollTo(0, this.$refs.selectedAbo[0].$el.offsetTop + 150)
      }, 500)
    }

    // check if the url has a param success. The param success is only set, if the user has tried to change his abo in stripe
    this.aboSuccessfullyChanged = this.$route.query.success ? this.$route.query.success === 'true' : null
  },
  watch: {
    aboSuccessfullyChanged: {
      async handler(val) {
        if (val) {
          await this.$store.dispatch('auth/fetchUser')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
